import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockOpenRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 8.5C6.275 8.5 6.51042 8.40208 6.70625 8.20625C6.90208 8.01042 7 7.775 7 7.5C7 7.225 6.90208 6.98958 6.70625 6.79375C6.51042 6.59792 6.275 6.5 6 6.5C5.725 6.5 5.48958 6.59792 5.29375 6.79375C5.09792 6.98958 5 7.225 5 7.5C5 7.775 5.09792 8.01042 5.29375 8.20625C5.48958 8.40208 5.725 8.5 6 8.5ZM3 11C2.725 11 2.48958 10.9021 2.29375 10.7063C2.09792 10.5104 2 10.275 2 10V5C2 4.725 2.09792 4.48958 2.29375 4.29375C2.48958 4.09792 2.725 4 3 4H6.5V3C6.5 2.30833 6.74375 1.71875 7.23125 1.23125C7.71875 0.74375 8.30833 0.5 9 0.5C9.69167 0.5 10.2812 0.74375 10.7688 1.23125C11.2563 1.71875 11.5 2.30833 11.5 3H10.5C10.5 2.58333 10.3542 2.22917 10.0625 1.9375C9.77083 1.64583 9.41667 1.5 9 1.5C8.58333 1.5 8.22917 1.64583 7.9375 1.9375C7.64583 2.22917 7.5 2.58333 7.5 3V4H9C9.275 4 9.51042 4.09792 9.70625 4.29375C9.90208 4.48958 10 4.725 10 5V10C10 10.275 9.90208 10.5104 9.70625 10.7063C9.51042 10.9021 9.275 11 9 11H3Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLockOpenRight);
export default ForwardRef;
